import React, { useEffect, useState, useCallback } from "react";

import Navbar from "../components/Navbar";
import Header from "./Header";
// import "./Header.css";
import "./MyBookings.css";

import moment from "moment";

import { Link, useNavigate } from "react-router-dom";
import host from "../config";
const MyBookings = () => {
  const navigate = useNavigate();

  // let host = "https://api.vmrdarental.com";
  // let host = "https://api.vmrdarental.com";
  const [paginatedBookingList, setPaginatedBookingList] = useState([]);

  const [noData, setNoData] = useState();
  const [bookingData, setBookingData] = useState([]);
  const [bookingList, setBookingList] = useState([]);
  const [statusCheck, setStatusCheck] = useState(false);
  const [isShow, invokeModal] = React.useState(false);
  const [editableRoom, setEditableRoom] = React.useState({});
  const [selectedRole, setSelectedRole] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [showPopup, setShowPopup] = useState(false);
  // const [cancellationReason, setCancellationReason] = useState("");
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [cancellationReason, setCancellationReason] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);

  const [selectedRI, setSelectedRI] = useState(""); // Stores selected RI value
  const [selectedBookingId, setSelectedBookingId] = useState(null); // Stores the booking ID
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [discountReason, setDiscountReason] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  //  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const openModal = (booking) => {
    setSelectedBooking(booking);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedBooking(null);
    setIsChecked(false);
  };

  const [refundReason, setRefundReason] = useState("");
  const [calculatedDiscount, setCalculatedDiscount] = useState(0); // ✅ Fix: Define state variable
  const [refundPercentage, setRefundPercentage] = useState(0);
  const [calculatedRefund, setCalculatedRefund] = useState(0);
  const [showRefundModal, setShowRefundModal] = useState(false);

  const handleProcessRefund = () => {
    if (!selectedBooking || !refundReason) {
      alert("Please select a booking and enter a reason.");
      return;
    }

    const payload = {
      booking_group_id: selectedBooking.booking_group_id, // Ensure correct field
      cao_ao_remarks: refundReason,
      added_by: userRole, // Ensure this is a valid user ID
    };

    console.log("🔹 Sending Payload:", payload); // Debugging

    fetch(`${host}/cao-ao-approval`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("✅ Response from API:", data);
        if (data.message) {
          alert("Verified Successfully and Assigned to CAO");
          setShowDiscountModal(false);
          myBookingsList(); // Refresh booking list
        } else {
          alert("Error: " + data.error);
        }
      })
      .catch((err) => {
        console.error("❌ Error:", err);
        alert("Something went wrong!");
      });
  };

  const handleReassignToAO = () => {
    if (!selectedBooking || !refundReason) {
      alert("Please select a booking and enter a reason.");
      return;
    }

    const payload = {
      booking_group_id: selectedBooking.booking_group_id,
      remarks: refundReason,
      added_by: userRole, // who reassigns (CAO / CAO-AO)
      attachment: null, // if you allow file upload later
    };

    console.log("🔹 Sending Reassign Payload:", payload);

    fetch(`${host}/reassign-to-ao`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("✅ Response from API:", data);
        if (data.message) {
          alert("Refund request reassigned to AO.");
          setShowDiscountModal(false);
          myBookingsList(); // Refresh booking list
        } else {
          alert("Error: " + data.error);
        }
      })
      .catch((err) => {
        console.error("❌ Error:", err);
        alert("Something went wrong!");
      });
  };

  useEffect(() => {
    if (selectedBooking) {
      setCalculatedRefund(selectedBooking.refund_amount || 0);
    }
  }, [selectedBooking]);

  const openDiscountModal = (booking) => {
    setSelectedBooking(booking);
    setDiscountPercentage("");
    setDiscountReason("");
    setShowDiscountModal(true);
  };

  const openPopup = (bookingGroupId) => {
    setSelectedBookingId(bookingGroupId); // Store the ID for API call
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedRI(""); // Reset selection
  };

  const handleApproval = async () => {
    if (!selectedRI) {
      alert("Please select an RI value before approving.");
      return;
    }

    try {
      console.log("📤 Sending request:", selectedBookingId, selectedRI);

      const response = await fetch(`${host}/approveBooking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: selectedBookingId,
          ri_value: selectedRI,
        }),
      });

      console.log("⏳ Waiting for response...");

      if (!response.ok) {
        throw new Error("Failed to approve booking");
      }

      const updatedBooking = await response.json();
      console.log("✅ API Response:", updatedBooking);

      if (updatedBooking.success) {
        alert("Venue successfully approved!");
        myBookingsList();
        closePopup(); // Close modal
      } else {
        throw new Error("Approval failed");
      }
    } catch (error) {
      console.error("❌ Error approving booking:", error);
    }
  };

  const handleCancelClick = (item) => {
    setSelectedItem(item); // Set the selected booking
    setShowCancelModal(true); // Show the modal
  };

  const cancelBooking = async (
    bookingGroupId,
    bookingDate,
    cancellationReason
  ) => {
    let userRole = localStorage.getItem("userRole");

    if (!userRole) {
      console.error("User type not found in localStorage");
      alert("User type not found. Please log in again.");
      return false;
    }

    userRole = parseInt(userRole, 10);

    console.log("Cancel Booking Request:", {
      bookingGroupId,
      bookingDate,
      cancellationReason,
      userRole,
    });

    try {
      const response = await fetch(
        `${host}/cancelBooking?bookingGroupId=${bookingGroupId}&reason=${encodeURIComponent(
          cancellationReason
        )}&userRole=${userRole}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      const data = await response.json();
      console.log("Server Response:", data);

      if (response.ok) {
        alert(data.message);
        return true; // Indicate success
      } else {
        alert("Cancellation failed: " + data.message);
        return false;
      }
    } catch (error) {
      console.error("Cancellation Error:", error);
      alert("Cancellation failed. Please try again later.");
      return false;
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setCancellationReason("");
    setSelectedBooking(null);
  };

  const handleModalSubmit = () => {
    if (!cancellationReason.trim()) {
      alert("Please provide a reason for cancellation.");
      return;
    }

    console.log("Cancellation reason:", cancellationReason); // Debugging
    cancelBooking(
      selectedBooking.booking_group_id,
      selectedBooking.date,
      cancellationReason
    );
    handleModalClose();
  };

  const handleApprove = async (bookingGroupId) => {
    if (!isChecked) {
      alert("Please confirm the details before approving.");
      return;
    }

    console.log("Approved Booking:", selectedBooking);

    try {
      console.log("Sending booking_group_id:", bookingGroupId); // Debugging

      const response = await fetch(`${host}/approveBooking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({ booking_group_id: bookingGroupId }), // Send in the body
      });

      if (!response.ok) {
        throw new Error("Failed to approve booking");
      }

      const updatedBooking = await response.json();

      if (updatedBooking.success) {
        alert("Venue successfully approved!"); // Show alert

        // 🔄 Re-fetch latest booking data after approval
        myBookingsList();

        closeModal();
      } else {
        throw new Error("Approval failed");
      }
    } catch (error) {
      console.error("Error approving booking:", error);
    }
  };

  const handlePageChange = (newPage) => {
    console.log("Page changed to:", newPage);
    setCurrentPage(newPage);

    const newPaginatedBookingList = bookingList.slice(
      (newPage - 1) * itemsPerPage,
      newPage * itemsPerPage
    );

    setPaginatedBookingList(newPaginatedBookingList);
  };

  const myBookingsListCallback = useCallback(() => {
    // myBookingsList();
  }, []);

  useEffect(() => {
    if (
      !localStorage.getItem("access_token") ||
      localStorage.getItem("access_token") === ""
    ) {
      navigate("/", "_self");
    }

    myBookingsListCallback();
    // myBookingsList();
  }, [currentPage, myBookingsListCallback]);

  let userRole = localStorage.getItem("userRole");
  let billingRequest = JSON.parse("{}");
  let srNo = 0;
  if (
    localStorage.getItem("access_token") == undefined ||
    localStorage.getItem("access_token") === ""
  ) {
    navigate("/", "_self");
  }

  // Add this inside your component function
  useEffect(() => {
    console.log("Booking List:", bookingList);
  }, [bookingList]);

  const summaryView = (booking_group_id) => {
    fetch(
      host +
        "/getBookingSummary?bookingGroupId=" +
        booking_group_id +
        "&access_token=" +
        localStorage.getItem("access_token") +
        "&time=" +
        Math.round(new Date().getTime() / 1000),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      }
    ).then((response) => {
      response.json().then((rooms) => {
        if (rooms.length === 0) {
          console.error("No rooms found");
          return;
        }

        let bookingDetailsDataFinal = [];
        const orderId = rooms[0].order_id;
        console.log("Order ID:", orderId);

        billingRequest.locationId = rooms[0].location_id;
        billingRequest.name = rooms[0].customer_name;
        billingRequest.address = rooms[0].address;
        billingRequest.contactno = rooms[0].contact_no;
        billingRequest.email = rooms[0].email_id;
        billingRequest.pan = rooms[0].pan_number;
        billingRequest.aadhaar = rooms[0].aadhaar_number;
        billingRequest.razorpay_status = rooms[0].razorpay_status;
        billingRequest.orderId = rooms[0].booking_id;
        billingRequest.bookingId = rooms[0].order_id;
        billingRequest.is_approved = rooms[0].is_approved;

        rooms.map((row) => {
          let tmpBookingDetailsDataFinal = JSON.parse("{}");
          tmpBookingDetailsDataFinal["room_name"] = row.room_name;
          tmpBookingDetailsDataFinal["bookingDate"] = row.date;
          tmpBookingDetailsDataFinal["amount"] = row.sub_total;
          tmpBookingDetailsDataFinal["selectedPersons"] = row.extra_persons;
          tmpBookingDetailsDataFinal["finalGrandTotalVal"] = row.sub_total;

          bookingDetailsDataFinal.push(tmpBookingDetailsDataFinal);
          console.log("Row Sub Total:", row.sub_total);
        });

        billingRequest.roomData = bookingDetailsDataFinal;
        localStorage.setItem("billingRequest", JSON.stringify(billingRequest));
        localStorage.setItem("bookingDetailsData", JSON.stringify("{}"));

        navigate("/BookingSummary", {
          state: {
            orderId: rooms[0].order_id,
            isApproved: rooms[0].is_approved,
          },
        });
      });
    });
  };

  console.log("tmpBookingDetailsDataFinal");
  const handleViewDocument = (fileUrl) => {
    if (!fileUrl) {
      alert("Document URL is not available.");
      return;
    }

    // Open the document in a new tab
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const myBookingsList = async () => {
    try {
      const response = await fetch(
        host +
          "/getMyBookingsList?access_token=" +
          localStorage.getItem("access_token") +
          "&time=" +
          Math.round(new Date().getTime() / 1000),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 403) {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("access_token"); // Clear token
        navigate("/login", { replace: true }); // Redirect to login page
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch bookings");
      }

      const rooms = await response.json();
      console.log(rooms, "rooms");

      if (!Array.isArray(rooms)) {
        throw new Error("Invalid response format");
      }

      let bookingListArray = [];
      let bookingListTmp = {};

      if (rooms.length === 0) {
        setNoData("No booking details available");
      }

      rooms.forEach((row) => {
        // Group by booking_group_id and room_id
        const roomKey = `${row.booking_group_id}-${row.room_id}`;

        if (bookingListTmp[roomKey] !== undefined) {
          let tmp = bookingListTmp[roomKey];
          tmp.room_names = tmp.room_names + ", " + row.accommodation_type;

          // Ensure the sub_total is added only once for the room
          // Only add if the sub_total is not already set for this room in the group
          if (!tmp.sub_total) {
            tmp.sub_total = row.sub_total;
          }
          bookingListTmp[roomKey] = tmp;
        } else {
          row.room_names = row.room_names;
          // Set sub_total once for each room in the booking group
          row.sub_total = row.sub_total;
          bookingListTmp[roomKey] = row;
        }
      });

      // Convert the object to an array
      Object.keys(bookingListTmp).forEach((key) => {
        bookingListArray.push(bookingListTmp[key]);
      });

      const updatedBookingList = bookingListArray.map((booking) => {
        const checkOutDate = moment(booking.date);
        const currentDate = moment();
        const isDateCompleted = currentDate.isAfter(checkOutDate, "day");

        return {
          ...booking,
          cancelDisabled: booking.status === "Canceled" || isDateCompleted,
        };
      });

      setBookingList(updatedBookingList);

      const newTotalPageCount = Math.ceil(
        updatedBookingList.length / itemsPerPage
      );
      setTotalPageCount(newTotalPageCount);

      // Update the paginated list based on the current page
      const newPaginatedBookingList = updatedBookingList.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

      setPaginatedBookingList(newPaginatedBookingList);

      console.log("Total Page Count:", newTotalPageCount);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      alert(
        "There was an error fetching your bookings. Please try again later."
      );
    }
  };

  const handleApplyDiscount = async () => {
    if (!discountPercentage || !discountReason) {
      alert("Please enter both discount percentage and reason.");
      return;
    }

    try {
      const response = await fetch(`${host}/applyDiscount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: selectedBooking.booking_group_id,
          discount_percentage: discountPercentage,
          reason: discountReason,
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert("Discount applied successfully!");
        setShowDiscountModal(false);
        myBookingsList();
      } else {
        alert("Failed to apply discount.");
      }
    } catch (error) {
      console.error("Error applying discount:", error);
    }
  };

  const handleRiChange = async (selectedRi, bookingGroupId) => {
    if (!selectedRi) return;

    try {
      const response = await fetch(`${host}/updateRoomBookingRI`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: bookingGroupId,
          ri_value: selectedRi,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to update RI value.");
      }

      alert("RI value updated successfully!"); // ✅ Alert before updating UI
      myBookingsList();
      // 🔄 Immediately update UI to replace dropdown with text
      setBookingList((prevBookings) =>
        prevBookings.map((booking) =>
          booking.booking_group_id === bookingGroupId
            ? { ...booking, ri_value: selectedRi }
            : booking
        )
      );
    } catch (error) {
      console.error("Error updating RI value:", error);
      alert("Error updating RI value.");
    }
  };

  const [totalPageCount, setTotalPageCount] = useState(1);

  const bookingSummary = () => {};

//   const handleReassign = async () => {
//   if (!selectedRole) {
//     alert("Please select a role to reassign.");
//     return;
//   }

//   try {
//     const response = await fetch(`${host}/reassign`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         booking_group_id: selectedBooking.booking_group_id,
//         remarks: refundReason,
//         added_by: userRole, // whoever is logged in
//         reassign_to: selectedRole, // new field for reassignment
//       }),
//     });

//     const data = await response.json();
//     if (response.ok) {
//       alert(data.message);
//       setShowDiscountModal(false);
//     } else {
//       alert(data.message || "Failed to reassign");
//     }
//   } catch (error) {
//     console.error("Error reassigning:", error);
//     alert("Something went wrong");
//   }
// };


// 🔹 State for reassign
// const [selectedRole, setSelectedRole] = useState("");
const [appStatus, setAppStatus] = useState("");

// 🔹 Role → App Status Mapping
const roleToStatusMap = {
  RI: "Waiting for Remarks",
  AO: "waiting for AO approval",
  Secretary: "waiting for comm-sec approval",
  CAO: "Waiting for CAO verification approval",
  "CAO-AO": "Waiting for CAO-AO Approval",
};

// 🔹 Handle Role Change
const handleRoleChange = (e) => {
  const role = e.target.value;
  setSelectedRole(role);
  setAppStatus(roleToStatusMap[role] || "");
};

// 🔹 Updated Reassign API Call
const handleReassign = async () => {
  if (!selectedRole) {
    alert("Please select a role to reassign.");
    return;
  }

  try {
    const response = await fetch(`${host}/reassign`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        booking_group_id: selectedBooking.booking_group_id,
        remarks: refundReason,
        added_by: userRole, // logged in role
        reassign_to: selectedRole,
        app_status: appStatus, // 🔹 now we pass the correct app_status automatically
      }),
    });

    const data = await response.json();
    if (response.ok) {
      alert(data.message);
      setShowDiscountModal(false);
    } else {
      alert(data.message || "Failed to reassign");
    }
  } catch (error) {
    console.error("Error reassigning:", error);
    alert("Something went wrong");
  }
};


  useEffect(() => {
    myBookingsList();
    myBookingsListCallback();
  }, [currentPage]);
  // const onChangeLocation = () => {
  //   myBookingsList();
  //   // populateAvailableRoomsInCalender(moment(nextDates[0]).format("DD-MMM-YYYY"));
  //   //checkAvailability();
  // };

  const [filters, setFilters] = useState({
    checkInDate: "",
    bookingDate: "",
    customerName: "",
    venueName: "",
    app_status: "",
  });

  // const handleFilterChange = (e) => {
  //   setFilters({ ...filters, [e.target.name]: e.target.value });
  // };
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
    setCurrentPage(1); // optional: reset to first page on filter change
  };

  // const filteredBookings = bookingList.filter((rm) => {
  //   return (
  //     (!filters.checkInDate ||
  //       moment(rm.date).format("DD-MMM-YYYY") ===
  //         moment(filters.checkInDate).format("DD-MMM-YYYY")) && // Filter by check-in date
  //     (!filters.bookingDate ||
  //       moment(rm.booking_date).format("DD-MMM-YYYY") ===
  //         moment(filters.bookingDate).format("DD-MMM-YYYY")) && // Filter by booking date
  //     (!filters.customerName ||
  //       rm.customer_name
  //         .toLowerCase()
  //         .includes(filters.customerName.toLowerCase())) &&
  //     (!filters.venueName ||
  //       rm.room_names
  //         .toLowerCase()
  //         .includes(filters.venueName.toLowerCase())) &&
  //     (!filters.app_status ||
  //       (rm.app_status || "")
  //         .toLowerCase()
  //         .includes(filters.app_status.toLowerCase()))
  //   );
  // });

    const filteredBookings = bookingList.filter((rm) => {
  return (
    (!filters.checkInDate ||
      rm.dates?.split(",").some(
        (d) =>
          moment(d).format("DD-MMM-YYYY") ===
          moment(filters.checkInDate).format("DD-MMM-YYYY")
      )) &&
    (!filters.bookingDate ||
      moment(rm.booking_date).format("DD-MMM-YYYY") ===
        moment(filters.bookingDate).format("DD-MMM-YYYY")) &&
    (!filters.customerName ||
      rm.customer_name
        ?.toLowerCase()
        .includes(filters.customerName.toLowerCase())) &&
    (!filters.venueName ||
      [
        rm.room_names,
        rm.accommodation_type
      ]
        .map((val) =>
          val?.toLowerCase()
            .replace(/['’]/g, "") // remove apostrophes
            .trim()
        )
        .some((val) =>
          val?.includes(
            filters.venueName.toLowerCase().replace(/['’]/g, "").trim()
          )
        )) &&
    (!filters.app_status ||
      (rm.app_status || "")
        .toLowerCase()
        .includes(filters.app_status.toLowerCase()))
  );
});
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const paginatedFilteredBookings = filteredBookings.slice(
    startIndex,
    endIndex
  );
  return (
    <div>
      <Header />
      {/* <Navbar /> */}
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-lg-2"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  content_back">
            <div className="row">
              <b>Booking Details</b>
            </div>
            <div className="filter-container">
              <div className="filter-item">
                <label>Event Date:</label>
                <input
                  type="date"
                  name="checkInDate"
                  value={filters.checkInDate}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="filter-item">
                <label>Booking Date:</label>
                <input
                  type="date"
                  name="bookingDate"
                  value={filters.bookingDate}
                  onChange={handleFilterChange}
                />
              </div>

              <div className="filter-item">
                <label>Customer Name:</label>
                <input
                  type="text"
                  name="customerName"
                  value={filters.customerName}
                  onChange={handleFilterChange}
                  placeholder="Enter Customer Name"
                />
              </div>

              <div className="filter-item">
                <label>Venue Name:</label>
                <input
                  type="text"
                  name="venueName"
                  value={filters.venueName}
                  onChange={handleFilterChange}
                  placeholder="Enter Venue Name"
                />
              </div>
              <div className="filter-item">
                <label>Status:</label>
                <input
                  type="text"
                  name="app_status"
                  value={filters.app_status}
                  onChange={handleFilterChange}
                  placeholder="Enter Status"
                />
              </div>
            </div>

            <div className="row" style={{ overflowX: "auto" }}>
              <table className="table table-striped responsive-table">
                <thead>
                  <tr
                    className="data-row-head"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <th>S No</th>
                    <th>Venue Details</th>
                    <th>Venue Type</th>
                    <th>Event Date</th>
                    <th>Contact Name</th>
                    <th>Contact No</th>
                    <th>Booking Date</th>
                    {/* <th>Booking Status</th> */}
                    <th>Amount</th>
                     <th>Payment Id</th>
                    <th>Payment Mode</th>
                    <th>app status</th>
                    {userRole == 7 && <th>Type of Event</th>}
                    {userRole == 7 && <th>electricity Attachment</th>}
                    {userRole == 7 && <th>damaged Attachment</th>}

                    {userRole == 7 && <th>Refund process</th>}
                      {userRole == 7 && <th>Reassign Status</th>}
                     {userRole == 7 &&  <th>discount amount</th>}
                  {userRole == 7 &&  <th>refund amount</th>}
                  </tr>
                </thead>
                <tbody style={{ whiteSpace: "nowrap" }}>
                  {paginatedFilteredBookings.map((rm, index) => (
                    <tr key={rm.booking_group_id} className={`data-row-data ${
    rm.app_status?.toLowerCase() == "refund successfully approved"
      ? "refund-success"
      : ""
  }`}>
                      <td style={{ textAlign: "center" }}>
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {rm.accommodation_type}
                      </td>
                      <td style={{ textAlign: "center" }}>{rm.room_names}</td>
                      {/* <td style={{ textAlign: "center" }}>
                        {moment(rm.date).format("DD-MMM-YYYY")}
                      </td> */}
                                           <td style={{ textAlign: "center" }}>
  {rm.dates
    ? (() => {
        const arr = rm.dates.split(",").map(d => moment(d).format("DD-MMM-YYYY"));
        return arr.length === 1 ? arr[0] : `${arr[0]} to ${arr[arr.length - 1]}`;
      })()
    : "-"}
</td>
                      <td style={{ textAlign: "center" }}>
                        {rm.customer_name}
                      </td>
                      <td style={{ textAlign: "center" }}>{rm.contact_no}</td>
                      <td style={{ textAlign: "center" }}>
                        {moment(rm.booking_date).format("DD-MMM-YYYY")}{" "}
                      </td>

                      <td style={{ textAlign: "center" }}>{rm.sub_total}</td>
                         <td style={{ textAlign: "center" }}>{rm.razorpay_payment_id}</td>
                      <td style={{ textAlign: "center" }}>{rm.payment_mode}</td>
                      <td style={{ textAlign: "center" }}>{rm.app_status}</td>

                      {/* Purpose (For userRole 1 & 2) */}
                      {userRole == 7 && <td>{rm.purpose}</td>}
                      {(userRole == 1 || userRole == 2) && (
                        <td>
                          {rm.discount}{" "}
                          <button
                            className="edit-button"
                            onClick={() => openDiscountModal(rm)}
                            style={{
                              cursor: "pointer",
                              background: "blue",
                              color: "white",
                              border: "none",
                              padding: "5px 10px",
                              borderRadius: "4px",
                              marginLeft: "5px",
                            }}
                          >
                            Refund process
                          </button>
                        </td>
                      )}

                      {(userRole == 7 || userRole == 2) && (
                        <td style={{ textAlign: "center" }}>
                          {/* {rm.reviews &&
                          rm.reviews.length > 0 &&
                          rm.reviews[0].electricityAttachment ? (
                            <a
                              href={rm.reviews[0].electricityAttachment}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View
                            </a>
                          ) : (
                            ""
                          )} */}
                          {rm.reviews &&
  rm.reviews.length > 0 &&
  rm.reviews[0].electricityAttachment ? (
    rm.reviews[0].electricityAttachment
      .split(",")
      .map((url, index) => (
        <a
          key={index}
          href={url.trim()}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "block", marginBottom: "4px" }}
        >
          View {index + 1}
        </a>
      ))
  ) : (
    ""
  )}
</td>
                       
                      )}

                      {(userRole == 7 || userRole == 2) && (
                   <td style={{ textAlign: "center" }}>
  {rm.reviews &&
  rm.reviews.length > 0 &&
  rm.reviews[0].damagedAttachment ? (
    rm.reviews[0].damagedAttachment
      .split(",")
      .map((url, index) => (
        <a
          key={index}
          href={url.trim()}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "block", marginBottom: "4px" }}
        >
          View {index + 1}
        </a>
      ))
  ) : (
    ""
  )}
</td>
                      )}

                      
                      {(userRole == 7 || userRole == 3) && (
                        <td>
                          {rm.discount}{" "}
                          <button
                            className="edit-button"
                            onClick={() => openDiscountModal(rm)}
                            disabled={
                              rm.app_status !== "Waiting for CAO-AO Approval"
                            } // Button disabled if rm.app !== status
                            style={{
                              cursor:
                                rm.app_status === "Waiting for CAO-AO Approval"
                                  ? "pointer"
                                  : "not-allowed",
                              background:
                                rm.app_status === "Waiting for CAO-AO Approval"
                                  ? "blue"
                                  : "gray",
                              color: "white",
                              border: "none",
                              padding: "5px 10px",
                              borderRadius: "4px",
                              marginLeft: "5px",
                              opacity:
                                rm.app_status === "Waiting for CAO-AO Approval"
                                  ? 1
                                  : 0.5, // Reduce opacity when disabled
                            }}
                          >
                            Verify Refund
                          </button>
                        </td>
                      )}
                      {userRole == 7 && (
                        <td style={{ textAlign: "center" }}>
                          {rm.reassign_status || ""}
                        </td>
                      )}
                      {userRole == 7 && (
                        <td style={{ textAlign: "center" }}>
                          {rm.discount_amount || ""}
                        </td> )}
                      {userRole == 7 && (
                                            <td>
  {rm?.app_status === "Refund Successfully Approved"
    ? rm?.refund_details?.[0]?.refund_amount || "-"
    : "-"}
</td> )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {showModal && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <h3>Reason for Cancellation</h3>
                  <textarea
                    value={cancellationReason}
                    onChange={(e) => setCancellationReason(e.target.value)}
                    placeholder="Enter reason for cancellation"
                    rows="4"
                    style={{ width: "100%" }}
                  />
                  <div style={{ marginTop: "10px" }}>
                    <button
                      onClick={handleModalSubmit}
                      style={{ marginRight: "10px" }}
                    >
                      Submit
                    </button>
                    <button onClick={handleModalClose}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

            


            {isModalOpen && selectedBooking && (
              <div className="modal-overlay">
                <div className="modal-container">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <h2 className="modal-title">Approve Booking</h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={closeModal}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedBooking.date).format("DD-MMM-YYYY")}
                        </span>
                      </div>
                    </div>

                    {/* Second Line: Customer Name, Phone, Email */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.email || "N/A"}
                        </span>
                      </div>
                    </div>

                    {/* Third Line: Tabular Format for Rent, GST, etc. */}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedBooking.total_rent}</td>
                          <td>₹{selectedBooking.total_gst}</td>
                          <td>₹{selectedBooking.total_security_deposit}</td>
                          <td>₹{selectedBooking.total_cleaning_charges}</td>
                          <td>₹{selectedBooking.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Purpose & Proof Attachment */}
                    <div className="row">
                      <div className="col-12">
                        <span>
                          <strong>Type of Event &nbsp;:</strong>
                        </span>
                        <span>&nbsp; {selectedBooking.purpose || "N/A"}</span>
                      </div>
                    </div>

                    {selectedBooking.file_url && (
                      <div className="row">
                        <div className="col-12">
                          <span>
                            <strong>Attachment of Proof &nbsp;:</strong>
                          </span>
                          <a href={selectedBooking.file_url} target="_blank">
                            &nbsp; view
                          </a>
                        </div>
                      </div>
                    )}

                    {/* Assigned to RI */}
                    <div className="row">
                      <div className="col-12">
                        <span>
                          <strong>Assigned to &nbsp;:</strong>
                        </span>
                        <span>
                          &nbsp; {selectedBooking.ri_value || "Not Assigned"}
                        </span>
                      </div>
                    </div>

                    {/* Checkbox Confirmation */}
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="confirmCheck"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="confirmCheck"
                      >
                        I have checked and confirmed that the above information
                        is correct.
                      </label>
                    </div>
                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button
                      onClick={() =>
                        handleApprove(selectedBooking.booking_group_id)
                      }
                      disabled={!isChecked}
                      className="approve-btn"
                    >
                      Approve
                    </button>
                    <button onClick={closeModal} className="cancel-btn">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showCancelModal && selectedItem && (
              <div className="modal-overlay">
                <div className="modal-container">
                  <div className="modal-header">
                    <h2 className="modal-title">Cancel Booking</h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={() => setShowCancelModal(false)}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    {/* Booking Details */}{" "}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedItem.date).format("DD-MMM-YYYY")}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.email || "N/A"}
                        </span>
                      </div>
                    </div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedItem.total_rent}</td>
                          <td>₹{selectedItem.total_gst}</td>
                          <td>₹{selectedItem.total_security_deposit}</td>
                          <td>₹{selectedItem.total_cleaning_charges}</td>
                          <td>₹{selectedItem.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>
                    {/* Cancellation Reason */}
                    <div className="row">
                      <div className="col-12">
                        <label>
                          <strong>Cancellation Reason</strong>
                        </label>
                        <textarea
                          value={cancelReason}
                          onChange={(e) => setCancelReason(e.target.value)}
                          className="popup-textarea"
                          placeholder="Enter reason"
                          rows={4}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button onClick={handleCancelClick} className="approve-btn">
                      Confirm Cancellation
                    </button>
                    <button
                      onClick={() => setShowCancelModal(false)}
                      className="cancel-btn"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/* refund */}
            {showDiscountModal && selectedBooking && (
              <div className="modal-overlay">
                <div className="modal-container">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <h2 className="modal-title">Approve Refund </h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={() => setShowDiscountModal(false)}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    {/* Venue & Event Details */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedBooking.date).format("DD-MMM-YYYY")}
                        </span>
                      </div>
                    </div>

                    {/* Customer Info */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.email || "N/A"}
                        </span>
                      </div>
                    </div>

                    {/* Charges Table */}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedBooking.total_rent}</td>
                          <td>₹{selectedBooking.total_gst}</td>
                          <td>₹{selectedBooking.total_security_deposit}</td>
                          <td>₹{selectedBooking.total_cleaning_charges}</td>
                          <td>₹{selectedBooking.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="row">
                 
                      <div className="col-3">
                        <label>Refund Amount</label>
                        {selectedBooking.refund_details &&
                        selectedBooking.refund_details.length > 0 ? (
                          selectedBooking.refund_details.map(
                            (refund, index) => (
                              <input
                                key={index}
                                type="text"
                                value={`₹${refund.refund_amount || 0}`}
                                readOnly
                                className="popup-input"
                                style={{ width: "100%" }}
                              />
                            )
                          )
                        ) : (
                          <p>No refund amount</p>
                        )}
                      </div>

                      {/* Right Section - Discount Display */}
                      <div className="col-4">
                        <label>
                          <strong>Discount Amount</strong>
                        </label>
                        <input
                          type="text"
                          value={`₹${selectedBooking.discount_amount || 0}`}
                          readOnly
                          className="popup-input"
                          style={{
                            backgroundColor: "#f0f0f0",
                            fontWeight: "bold",
                          }}
                        />
                      </div>

                      {/* Right Section - Reason */}
                      {/* <div className="col-4">
                        <label>
                          <strong>Total Refund Amount</strong>
                        </label>
                        <input
                          type="text"
                          value={`₹${Number(calculatedRefund) + (selectedBooking.discount || 0)}`} // Static refund amount
                          readOnly
                          className="popup-input"
                          style={{
                            backgroundColor: "#f0f0f0",
                            fontWeight: "bold",
                            width: "100%",
                          }}
                        />
                      </div> */}
                      <div className="col-4">
                        <label>
                          <strong>Total Refund Amount</strong>
                        </label>
                        <input
                          type="text"
                          value={`₹${
                            (selectedBooking.refund_details?.reduce(
                              (acc, refund) =>
                                acc + Number(refund.refund_amount || 0),
                              0
                            ) || 0) +
                            (Number(selectedBooking.discount_amount) || 0)
                          }`}
                          readOnly
                          className="popup-input"
                          style={{
                            backgroundColor: "#f0f0f0",
                            fontWeight: "bold",
                            width: "100%",
                          }}
                        />
                      </div>
                    </div>

                    {/* ================= CAO Remarks ================= */}
                    {/* <div className="row mt-3">
                      <div className="col-12">
                        <h6 style={{ marginBottom: "6px", color: "#333" }}>
                          CAO Remarks
                        </h6>
                        {selectedBooking?.cao_remarks &&
                        selectedBooking.cao_remarks.length > 0 ? (
                          selectedBooking.cao_remarks.map((remark, index) => (
                            <div
                              key={index}
                              className="remark-box"
                              style={{
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                                padding: "8px",
                                marginBottom: "6px",
                                background: "#f9f9f9",
                              }}
                            >
                              <p style={{ margin: "0 0 4px" }}>
                                <strong>Remark:</strong>{" "}
                                {remark.cao_remarks || "N/A"}
                              </p>
                            </div>
                          ))
                        ) : (
                          <p>No CAO remarks available</p>
                        )}
                      </div>
                    </div> */}

                    {/* ================= All Remarks ================= */}
                    <div className="row mt-3">
                      <div className="col-12">
                        <h6 style={{ marginBottom: "8px", color: "#007bff" }}>
                          Remarks
                        </h6>

                        <div
                          style={{
                            maxHeight: "200px",
                            overflowY: "auto",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "10px",
                            background: "#f9f9f9",
                          }}
                        >
                          {(() => {
                            const allRemarks = [];

                            if (selectedBooking?.refund_details?.length) {
                              selectedBooking.refund_details.forEach((r) => {
                                allRemarks.push({
                                  role: "AO",
                                  date: r.refunded_at,
                                  comment: r.refund_reason,
                                });
                              });
                            }

                            if (selectedBooking?.cao_remarks?.length) {
                              selectedBooking.cao_remarks.forEach((r) => {
                                allRemarks.push({
                                  role: "CAO",
                                  date: r.created,
                                  comment: r.cao_remarks,
                                });
                              });
                            }

                            if (selectedBooking?.cao_ao_remarks?.length) {
                              selectedBooking.cao_ao_remarks.forEach((r) => {
                                allRemarks.push({
                                  role: "CAO-AO",
                                  date: r.created,
                                  comment: r.cao_ao_remarks,
                                });
                              });
                            }

                            if (selectedBooking?.commisioner_remarks?.length) {
                              selectedBooking.commisioner_remarks.forEach(
                                (r) => {
                                  allRemarks.push({
                                    role: "Secretary",
                                    date: r.created,
                                    comment: r.sec_remarks,
                                  });
                                }
                              );
                            }

                            if (selectedBooking?.reviews?.length) {
                              selectedBooking.reviews.forEach((r) => {
                                allRemarks.push({
                                  role: "RI",
                                  date: r.created,
                                  comment: r.remark,
                                });
                              });
                            }

                            // 🔹 Role-based priority order
                            const rolePriority = {
                              CAO: 1,
                              "CAO-AO": 2,
                              Secretary: 3,
                              AO: 4,
                              "RI": 5,
                            };

                            return allRemarks.length > 0 ? (
                              allRemarks
                                .sort((a, b) => {
                                  if (
                                    rolePriority[a.role] ===
                                    rolePriority[b.role]
                                  ) {
                                    // same role → sort by date ascending (oldest → newest)
                                    return new Date(a.date) - new Date(b.date);
                                  }
                                  return (
                                    rolePriority[a.role] - rolePriority[b.role]
                                  );
                                })
                                .map((remark, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      marginBottom: "10px",
                                      paddingBottom: "8px",
                                      borderBottom: "1px dashed #ccc",
                                    }}
                                  >
                                    <p style={{ margin: "0 0 4px" }}>
                                      <strong>
                                        {moment(remark.date).format(
                                          "DD-MMM-YYYY"
                                        )}
                                        , {remark.role}
                                      </strong>
                                    </p>
                                    <p style={{ margin: 0 }}>
                                      {remark.comment || "N/A"}
                                    </p>
                                  </div>
                                ))
                            ) : (
                              <p>No remarks available</p>
                            );
                          })()}
                        </div>
                      </div>
                    </div>

                    {/* Total Refund Calculation */}
                    <div className="row">
                      <div className="col-8">
                        <label>
                          <strong>Reason</strong>
                        </label>
                        <textarea
                          value={refundReason}
                          onChange={(e) => setRefundReason(e.target.value)}
                          className="popup-textarea"
                          placeholder="Enter reason"
                          rows={4}
                          style={{ width: "100%", height: "66px" }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button
                      onClick={handleProcessRefund}
                      className="approve-btn"
                    >
                      Approve Refund
                    </button>
               

  <select
  value={selectedRole}
  onChange={handleRoleChange}
  className="popup-input"
>
  <option value="">-- Select Role to Reassign --</option>
  <option value="RI">RI</option>
  <option value="AO">AO</option>
  <option value="Secretary">Secretary</option>
  <option value="CAO">CAO</option>
  <option value="CAO-AO">CAO-AO</option>
</select>

{/* 🔹 Show app status preview */}
{appStatus && (
  <p style={{ marginTop: "6px", fontStyle: "italic", color: "#666" }}>
    New Status: {appStatus}
  </p>
)}

<button onClick={handleReassign} className="cancelButton">
  Reassign
</button>

                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-2"></div>
            <div className="pagination">
              <button
                className="btn-next-my"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span
                style={{ paddingTop: "15px" }}
              >{`Page ${currentPage} of ${totalPageCount}`}</span>
              <button
                className="btn-next-my"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPageCount}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyBookings;
